<template>
  <AntModal
    v-model="showModal"
    @ok="closeModal"
    :destroyOnClose="true"
    :footer="null"
    :bodyStyle="bodyStyle"
  >
    <slot></slot>
  </AntModal>
</template>

<script>
import AntModal from 'ant-design-vue/lib/modal'
import 'ant-design-vue/lib/modal/style/index.css'

export default {
  components: {
    AntModal
  },
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      bodyStyle: { padding: '48px 0 0 0' }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
